import type { DependencyList } from "react";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { runningInBrowser } from "~/const/browser";

type Args = {
  onBeforeReload: () => void;
  deps?: DependencyList;
};

export const useOnBeforeReload = ({ onBeforeReload, deps = [] }: Args) => {
  const { events } = useRouter();

  useEffect(() => {
    if (!runningInBrowser) return;

    // SPA遷移時の処理
    events.on("routeChangeStart", onBeforeReload);
    // ブラウザリロード時の処理
    window.addEventListener("beforeunload", onBeforeReload, {
      passive: true,
    });
    return () => {
      events.off("routeChangeStart", onBeforeReload);
      window.removeEventListener("beforeunload", onBeforeReload);
    };
  }, deps);
};
